// eslint-disable-next-line import/no-cycle
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  OTP_SEND_CODE,
  OTP_SEND_CODE_SUCCESS,
  OTP_SEND_CODE_ERROR,
  RESET_FORM_DATA,
  CLEAN_MOBILE,
  CHANGE_MOBILE,
  UPDATE_USER_AUTH,
} from '../actions';

export const updateUser = (user) => ({
  type: UPDATE_USER_AUTH,
  payload: user,
});

export const resetData = () => ({
  type: RESET_FORM_DATA,
});

export const changeMobile = (mobile) => ({
  type: CHANGE_MOBILE,
  payload: { mobile }
});

export const cleanMobile = () => ({
  type: CLEAN_MOBILE,
});

export const otpSend = (mobile) => ({
  type: OTP_SEND_CODE,
  payload: { mobile },
});

export const otpSendSuccess = (message, seconds) => ({
  type: OTP_SEND_CODE_SUCCESS,
  payload: { message, seconds },
});
export const otpSendError = (message, seconds) => ({
  type: OTP_SEND_CODE_ERROR,
  payload: { message, seconds },
});

export const loginUser = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history },
});

export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});

export const forgotPassword = (forgotUserMail, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotUserMail, history },
});
export const forgotPasswordSuccess = (forgotUserMail) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotUserMail,
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message },
});

export const resetPassword = ({ resetPasswordCode, newPassword, history }) => ({
  type: RESET_PASSWORD,
  payload: { resetPasswordCode, newPassword, history },
});
export const resetPasswordSuccess = (newPassword) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: newPassword,
});
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message },
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history },
});
export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});
export const registerUserError = (message) => ({
  type: REGISTER_USER_ERROR,
  payload: { message },
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});
